import React from 'react';

const Services = () => {
  const services = [
    {
      icon: "ri-flow-chart",
      title: "Workflow & Process Redesign",
      description: "We analyze real business workflows and eliminate inefficiencies."
    },
    {
      icon: "ri-settings-3-line",
      title: "ERP Optimization & Custom Systems",
      description: "Fix adoption gaps and align systems to actual operations."
    },
    {
      icon: "ri-database-2-line",
      title: "Inventory & Procurement Automation",
      description: "Real-time tracking, automated indents, integrated workflows."
    },
    {
      icon: "ri-bar-chart-box-line",
      title: "Business Intelligence & AI Layer",
      description: "Dynamic dashboards, pivot analytics, AI-powered suggestions."
    },
    {
      icon: "ri-refresh-line",
      title: "Ongoing Optimization & Support",
      description: "Continuous improvements with lightweight maintenance."
    }
  ];

  return (
    <section id="services" className="py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">How We Help Businesses Transform Operations</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            We build systems that reduce costs, save hours, and streamline teams — delivering measurable business results.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
          {services.map((service, index) => (
            <div key={index} className="service-card bg-white p-8 rounded-lg shadow-md transition-all duration-300">
              <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} ri-xl text-primary`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-700">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
